import { fetch } from '@/shared/fetch';

export const softDeleteWeightLog = async (id: number) => {
    return await fetch<string>(`/api/sundvaegt/log/${id}`, 'DELETE');
};
